module.exports = __webpack_public_path__ + "img/deactive-roster-blue-outline.ef9c1991.svg";